import { modes } from '../../../components/ui/MainHeader/components/Search';

const getStore = (state) => state.housingStockStore;

export const selectEntrancesInView = (state) => getStore(state).entrancesInView;

export const selectGridData = (state) => getStore(state).flatsGridData;

export const selectFlatsTableData = (state) => getStore(state).flatsTableData;

export const selectFlatsTableDataByEntranceName = (state, entranceName) =>
  selectFlatsTableData(state)?.data?.get(entranceName);

export const selectTableEntrances = (state) =>
  selectFlatsTableData(state)?.entrances;

export const selectEntranceName = (state) => getStore(state).activeEntranceName;

export const selectFlatsView = (state) => getStore(state).flatsView;

export const selectGridPreview = (state) => getStore(state).flatsGridPreview;

export const selectHasGridData = (state) =>
  Boolean(selectGridData(state).length);

export const selectHasGridPreview = (state) =>
  Boolean(Object.values(selectGridPreview(state)).every(Boolean));

export const selectHasGridPreviewData = (state) => {
  const previewData = selectGridPreview(state);
  return Boolean(previewData?.data?.length);
};

export const selectUserInfo = (state) => state.authentication.userInfo;

export const selectFlatsSearch = (state) =>
  state.housingStockStore.searchFieldValue[modes.flats];

export const selectFlatsData = (state) =>
  state.housingStockStore.selectedFlatsData;
